(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7767],{

/***/ 997767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_MemberLogin; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(656173);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(368060);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
;// CONCATENATED MODULE: ./src/assets/svgExports/OtpRightArrow.js

var OtpRightArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.031",
        height: "16.031",
        viewBox: "0 0 16.031 16.031",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Path_49",
            "data-name": "Path 49",
            d: "M-3.984-12.984H-16.172l5.578-5.625L-12-20.016-20.016-12-12-3.984l1.406-1.406-5.578-5.625H-3.984Z",
            transform: "translate(-3.984 -3.984) rotate(180)",
            fill: "#fff"
        })
    });
};

// EXTERNAL MODULE: ./src/containers/MemberLogin/MemberLogin.module.scss
var MemberLogin_module = __webpack_require__(891642);
var MemberLogin_module_default = /*#__PURE__*/__webpack_require__.n(MemberLogin_module);
// EXTERNAL MODULE: ./src/utils/sendWhatsappMessage.js
var sendWhatsappMessage = __webpack_require__(136290);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/components/DesktopView.js





var DesktopView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var handleMobileInputChange = function(e) {
        props.handleInputChange("phone", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 10);
    };
    var handleOtpInputChange = function(e) {
        props.handleInputChange("otp", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
    };
    var onContactUsClick = function() {
        var ref, ref1;
        (0,sendWhatsappMessage/* sendWhatsappMessage */.i)("Hi ".concat(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_name, ",\n\n                         I'm unable to access your website\n                         ").concat(props === null || props === void 0 ? void 0 : (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : ref1.store_url));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MemberLogin_module_default()).desktopView,
            children: props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.logo_image,
                                height: "44px",
                                width: "44px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 pt16px f16px fw5 black-color",
                                children: [
                                    "Welcome to ",
                                    (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 f22px fw5 c1C1C1C pt32px",
                                children: [
                                    "OTP sent to ",
                                    props.phone
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: props.invalidOtp ? (MemberLogin_module_default()).formControlOtpInvalid : (MemberLogin_module_default()).formControlOtp,
                        value: props.OTP,
                        placeholder: "Enter 4 digit OTP",
                        onChange: handleOtpInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: 300,
                                    transform: "translate(343px , 18px)"
                                },
                                children: !props.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "timer mt20px db",
                                    style: {
                                        transform: "translate(133px , -18px)"
                                    },
                                    children: "0:".concat(props.timer)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        width: 300,
                                        color: "#6C6C6C"
                                    },
                                    children: "Did not receive OTP?"
                                })
                            }),
                            props.isTimeUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pointer fw7 f14px relative z-1",
                                style: {
                                    transform: "translate(425px , 20px)"
                                },
                                onClick: function() {
                                    return props.resendOTP();
                                },
                                children: "Send Again"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: props.invalidOtp ? {
                            color: "red",
                            transform: "translateY(-19px)"
                        } : {
                            color: "red",
                            transform: "translateY(-19px)",
                            visibility: "hidden"
                        },
                        children: "Invalid OTP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-end justify-between",
                        style: {
                            transform: "translateY(-20px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 flex c2F80ED pointer f14px fw5",
                                    style: {
                                        paddingBottom: "1.38rem"
                                    },
                                    onClick: props.toggleOTPsent,
                                    children: "Change number?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                style: {
                                    transform: "translate(16px , 0)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                        backgroundColor: props.OTP.length === 4 && !props.invalidOtp ? "#000000" : "#00000033",
                                        roundness: (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
                                        style: {
                                            borderRadius: "4rem",
                                            borderWidth: "0px"
                                        },
                                        py: "21px",
                                        mx: "auto",
                                        mt: "81px",
                                        pr: "4rem",
                                        pl: "3rem",
                                        fontSize: 18,
                                        className: props.OTP.length === 0 ? "cursor-auto" : "",
                                        isDisable: props.OTP.length !== 4,
                                        onClick: function() {
                                            return props.submitVerifyOTP();
                                        },
                                        label: "VERIFY"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            transform: "translate(-58px, 105px)"
                                        },
                                        onClick: function() {
                                            return props.submitVerifyOTP();
                                        },
                                        className: "pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: props === null || props === void 0 ? void 0 : (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
                                height: "44px",
                                width: "44px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 pt16px f16px fw5 black-color",
                                children: [
                                    "Welcome to ",
                                    (ref6 = props.storeInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store_info) === null || ref7 === void 0 ? void 0 : ref7.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mv0 f22px fw5 c1C1C1C pt32px",
                                children: "Login using Mobile Number"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: (MemberLogin_module_default()).formControl,
                        value: props.phone,
                        placeholder: "Enter your mobile Number",
                        onChange: handleMobileInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: props.memberOnlyAccessError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start mt16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/red-info-icon.svg",
                                    width: "14px",
                                    height: "14px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f14px fw4 pl10px",
                                    style: {
                                        color: "#F54C52"
                                    },
                                    children: "Sorry, you don’t have permission to access this website."
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "c464646 f14px fw5 mv0 ".concat(props.memberOnlyAccessError ? "pt12px" : "pt20px"),
                        children: [
                            "For any query,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "c2F80ED",
                                style: {
                                    border: "none",
                                    cursor: "pointer",
                                    backgroundColor: "white"
                                },
                                onClick: onContactUsClick,
                                children: "Contact us"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            style: {
                                transform: "translate(16px , -22px)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    style: {
                                        borderRadius: "4rem",
                                        borderWidth: "0px"
                                    },
                                    backgroundColor: props.phone.length === 10 && !props.memberOnlyAccessError ? "#000000" : "#00000033",
                                    roundness: (ref8 = props.storeInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness,
                                    width: "174px",
                                    py: "24px",
                                    mx: "auto",
                                    whiteSpace: "nowrap",
                                    mt: props.memberOnlyAccessError ? "59px" : "85px",
                                    pr: "4rem",
                                    pl: "2.5rem",
                                    fontSize: 18,
                                    isDisable: props.phone && props.phone.length !== 10 || !props.phone || props.memberOnlyAccessError,
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    label: "GET OTP"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        transform: props.memberOnlyAccessError ? "translate(-43px, 85px)" : "translate(-43px, 112px)"
                                    },
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    className: "pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_DesktopView = (DesktopView);

// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/components/MobileView.js







var MobileView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var mobileNumberInputRef = (0,react.useRef)();
    var otpInputRef = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    (0,react.useEffect)(function() {
        if (isComponentMounted) {
            var ref, ref1;
            mobileNumberInputRef === null || mobileNumberInputRef === void 0 ? void 0 : (ref = mobileNumberInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            otpInputRef === null || otpInputRef === void 0 ? void 0 : (ref1 = otpInputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            return function() {
                document.getElementsByTagName("body")[0].style.overflowY = "auto";
            };
        }
    }, [
        isComponentMounted
    ]);
    var handleMobileInputChange = function(e) {
        props.handleInputChange("phone", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 10);
    };
    var handleOtpInputChange = function(e) {
        props.handleInputChange("otp", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
    };
    var onContactUsClick = function() {
        var ref, ref1;
        (0,sendWhatsappMessage/* sendWhatsappMessage */.i)("Hi ".concat(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_name, ",\n\n                         I'm unable to access your website\n                         ").concat(props === null || props === void 0 ? void 0 : (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : ref1.store_url));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MemberLogin_module_default()).mobileView,
        children: props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.logo_image,
                            height: "40px",
                            width: "40px"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 pt16px f16px fw6 c393939",
                            children: [
                                "Welcome to ",
                                (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-end justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mv0 f14px fw5 black-color pt34px",
                                    children: [
                                        "OTP sent to ",
                                        props.phone
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f12px fw5 c2F80ED",
                                    onClick: props.toggleOTPsent,
                                    children: "Change number?"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: props.invalidOtp ? (MemberLogin_module_default()).formControlOtpInvalid : (MemberLogin_module_default()).formControlOtp,
                            value: props.OTP,
                            ref: otpInputRef,
                            placeholder: "Enter 4 Digit OTP",
                            onChange: handleOtpInputChange
                        }),
                        !props.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (MemberLogin_module_default()).timerInProgress,
                            children: "0:".concat(props.timer)
                        }) : null,
                        props.isTimeUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (MemberLogin_module_default()).timerUp,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "c6C6C6C mv0 f12px",
                                    children: "Did not receive OTP?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 fw7 pt4px f12px pointer",
                                    onClick: function() {
                                        return props.resendOTP();
                                    },
                                    children: "Send OTP"
                                })
                            ]
                        }),
                        props.invalidOtp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (MemberLogin_module_default()).invalidOtp,
                            children: "Invalid OTP"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    backgroundColor: props.OTP.length === 4 && !props.invalidOtp ? "#000000" : "#00000033",
                                    roundness: (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
                                    fluid: true,
                                    py: "15px",
                                    mt: "129px",
                                    pr: "4rem",
                                    pl: "3rem",
                                    fontSize: 18,
                                    style: {
                                        borderRadius: 100,
                                        borderWidth: "0px"
                                    },
                                    isDisable: props.OTP.length !== 4,
                                    onClick: function() {
                                        return props.submitVerifyOTP();
                                    },
                                    label: "Verify"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "34%",
                                        right: "36%"
                                    },
                                    onClick: function() {
                                        return props.submitVerifyOTP();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: props === null || props === void 0 ? void 0 : (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
                            height: "40px",
                            width: "40px"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 pt16px f16px fw6 c393939",
                            children: [
                                "Welcome to ",
                                (ref6 = props.storeInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store_info) === null || ref7 === void 0 ? void 0 : ref7.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mv0 f14px fw5 black-color pt34px",
                            children: "Login using Mobile Number"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (MemberLogin_module_default()).formControl,
                            value: props.phone,
                            ref: mobileNumberInputRef,
                            placeholder: "Enter your mobile Number",
                            onChange: handleMobileInputChange
                        }),
                        props.memberOnlyAccessError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start absolute",
                            style: {
                                top: 70
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/red-info-icon.svg",
                                    width: "12px",
                                    height: "12px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f12px fw4 pl10px",
                                    style: {
                                        color: "#F54C52"
                                    },
                                    children: "Sorry, you don’t have permission to access this website."
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginTop: 94
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    backgroundColor: props.phone.length === 10 && !props.memberOnlyAccessError ? "#000000" : "#00000033",
                                    roundness: (ref8 = props.storeInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness,
                                    fluid: true,
                                    style: {
                                        borderRadius: "2rem",
                                        borderWidth: "0px"
                                    },
                                    py: "15px",
                                    pr: "3rem",
                                    fontSize: 18,
                                    isDisable: props.phone && props.phone.length !== 10 || !props.phone || props.memberOnlyAccessError,
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    label: "Get OTP"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "34%",
                                        right: "36%"
                                    },
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "c464646 f12px fw5 mv0 tc pt16px",
                            children: [
                                "For any query,",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "c2F80ED",
                                    style: {
                                        border: "none",
                                        cursor: "pointer",
                                        backgroundColor: "white"
                                    },
                                    onClick: onContactUsClick,
                                    children: "Contact us"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_MobileView = (MobileView);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./src/utils/regex.js
var regex = __webpack_require__(936083);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/index.js















var MemberLogin = function(param) {
    var storeInfo = param.storeInfo;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var width = (0,getWindowDimension/* default */.Z)().width;
    var timerID = null;
    var ref = (0,react.useState)({
        phone: "",
        OTP: "",
        OTPsent: false,
        timer: 59,
        isTimeUp: false,
        invalidOtp: false,
        currentDeviceWidth: 0,
        memberOnlyAccessError: false
    }), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access)) router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        else {
            dispatch((0,user/* setLogout */.wt)());
            LocalStorageHelper/* default.delete */.Z["delete"]("auth_token");
        }
    }, []);
    (0,react.useEffect)(function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentDeviceWidth: width
            });
        });
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        if (state.OTPsent) {
            startTimer();
        }
        return function() {
            /** Clear the Inteeval if any */ if (timerID != null) {
                clearInterval(timerID);
            }
        };
    }, [
        state.OTPsent
    ]);
    var verifyOTPCallback = function(status) {
        if (status) {
            LocalStorageHelper/* default.add */.Z.add("isMemberAllowed&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id), true);
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo.store_info.domain));
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    invalidOtp: true
                });
            });
        }
    };
    var validateInput = function(validationType) {
        switch(validationType){
            case "email":
                {
                    return (0,regex/* emailRegex */.HN)();
                }
            case "alpha_numeric":
                {
                    return (0,regex/* alphaNumericLettersRegex */.fw)();
                }
            case "alpha_space":
                {
                    return (0,regex/* alphabetsAndSpaceRegex */.PG)();
                }
            case "address":
                {
                    return (0,regex/* addressRegex */.L_)();
                }
            default:
                {
                    return /[^\d]/gi;
                }
        }
    };
    var handleInputChange = function(key, value, validationType, minLength, maxLength) {
        if (value.length > maxLength) value = value.substring(0, maxLength);
        value = value.replace(validateInput(validationType), "");
        if (!isNaN(value) && key === "phone") setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phone: value,
                memberOnlyAccessError: false
            });
        });
        else if (!isNaN(value) && key === "otp") {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    OTP: value
                });
            });
            if (value.length < 4) {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        invalidOtp: false
                    });
                });
            }
        }
    };
    var setPhoneNumber = function() {
        var phoneReg = /(6|7|8|9)\d{9}/;
        if (state.phone && state.phone.length === 10 && state.phone.match(phoneReg)) {
            var ref;
            var queryParams = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access) ? "&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) : "";
            var callback = function(status) {
                if (status) setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        OTPsent: true
                    });
                });
                else setState(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        memberOnlyAccessError: true
                    });
                });
            };
            dispatch((0,auth/* generateOTP */.P)(state.phone, router, "web", queryParams, callback));
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Invalid Phone Number!");
        }
    };
    // Start the timmer
    var startTimer = function() {
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    // Increase the timing (second) tick
    var tick = function(seconds) {
        var updatedTime;
        if (seconds > 0) {
            updatedTime = (seconds < 10 ? "0" : "") + String(seconds);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    timer: updatedTime
                });
            });
        } else {
            clearInterval(timerID);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    timer: 59,
                    isTimeUp: true
                });
            });
        }
    };
    var resendOTP = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isTimeUp: false
            });
        });
        dispatch((0,auth/* generateOTP */.P)(state.phone));
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    var handleChange = function(val) {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OTP: val
            });
        });
    };
    var submitVerifyOTP = function() {
        var data = {
            phone: state.phone,
            otp: state.OTP
        };
        if (state.OTP.length === 4) {
            dispatch((0,auth/* verifyOTP */.qD)(data, router, false, verifyOTPCallback));
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Please enter valid OTP");
        }
    };
    var toggleOTPsent = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OTPsent: !state.OTPsent,
                phone: "",
                timer: 59,
                isTimeUp: false,
                invalidOtp: false
            });
        });
    };
    var Props = {
        OTP: state.OTP,
        OTPsent: state.OTPsent,
        phone: state.phone,
        timer: state.timer,
        isTimeUp: state.isTimeUp,
        memberOnlyAccessError: state.memberOnlyAccessError,
        storeInfo: storeInfo,
        invalidOtp: state.invalidOtp,
        setPhoneNumber: setPhoneNumber,
        handleInputChange: handleInputChange,
        resendOTP: resendOTP,
        handleChange: handleChange,
        submitVerifyOTP: submitVerifyOTP,
        toggleOTPsent: toggleOTPsent
    };
    return state.currentDeviceWidth <= constants/* MAX_MOBILE_WIDTH */.Cf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileView, (0,_object_spread/* default */.Z)({}, Props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DesktopView, (0,_object_spread/* default */.Z)({}, Props));
};
/* harmony default export */ var containers_MemberLogin = (MemberLogin);


/***/ }),

/***/ 891642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"desktopView":"MemberLogin_desktopView__ob3bF","formControl":"MemberLogin_formControl__nTHfH","formControlOtp":"MemberLogin_formControlOtp__8Csyq","formControlOtpInvalid":"MemberLogin_formControlOtpInvalid__X_DZ1","mobileView":"MemberLogin_mobileView__jFuaF","invalidOtp":"MemberLogin_invalidOtp__MiT6F","timerUp":"MemberLogin_timerUp__JEZ0o","timerInProgress":"MemberLogin_timerInProgress__e5L8V"};

/***/ })

}]);